import { Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CommonAlert from 'src/common/CommonAlert';
import { infoModalSxs } from 'src/content/billing/components/newChangePlan';
import { cancelSubscriptionText, infoModalTexts } from 'src/common/config/TextMessage';

interface DeactivateHeaderProps {
  isCancel: boolean;
  isLocalSeo: boolean;
  handCloseModal: () => void;
}

const DeactivateHeader = ({ isCancel, isLocalSeo, handCloseModal }: DeactivateHeaderProps) => {
  return (
    <>
      <Box sx={infoModalSxs?.freeDowngradeHeadBox}>
        <Typography sx={infoModalSxs?.freeDowngradeTitle}>
          {isCancel ? cancelSubscriptionText : 'De-Activate Account'}
        </Typography>
        <IconButton
          aria-label="close"
          className="hover:rounded-lg"
          sx={infoModalSxs?.iconBtn}
          onClick={handCloseModal}
        >
          <CloseIcon sx={{ color: 'var(--color-text-sidebar-icon) !important' }} />
        </IconButton>
      </Box>
      <Typography sx={infoModalSxs?.freeDowngradeDesc}>
        {isLocalSeo
          ? infoModalTexts?.freeLocalSeoDowngradeDesc
          : infoModalTexts?.freeDowngradeDesc}
      </Typography>
      <CommonAlert
        severity="warning"
        message={isCancel ? infoModalTexts?.cancelPlanNote : infoModalTexts?.deactivateNote}
        sx={{ marginTop: '8px' }}
      />
    </>
  );
};

export default DeactivateHeader;
